var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGooglePlay = function SvgGooglePlay(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 41,
    viewBox: "0 0 109 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2226_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56502 0.760742C2.39548 0.760742 0.636719 2.51951 0.636719 4.68905V36.1155C0.636719 38.2851 2.39548 40.0438 4.56503 40.0438H104.082C106.252 40.0438 108.01 38.2851 108.01 36.1155V4.68905C108.01 2.51951 106.252 0.760742 104.082 0.760742H4.56502Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2226_2279)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2226_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7347 22.9385L8.95637 17.046C8.66949 16.8823 8.38261 16.8414 8.13672 16.9232L16.9889 25.721L19.7347 22.9385Z",
    fill: "url(#paint0_linear_2226_2279)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7751 28.5042L23.4635 26.4991C24.2012 26.0899 24.2012 25.4352 23.4635 25.026L19.7751 22.98L16.9883 25.7216L19.7751 28.5042Z",
    fill: "url(#paint1_linear_2226_2279)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13629 16.8823C7.80843 17.0051 7.60352 17.3324 7.60352 17.8235V33.6186C7.60352 34.1096 7.80843 34.437 8.13629 34.5597L16.9885 25.721L8.13629 16.8823Z",
    fill: "url(#paint2_linear_2226_2279)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13672 34.5599C8.38261 34.6417 8.66949 34.6008 8.95637 34.4371L19.7347 28.5037L16.9889 25.7212L8.13672 34.5599Z",
    fill: "url(#paint3_linear_2226_2279)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2226_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8292 32.6782L101.451 22.0391H99.9457L97.808 27.3435H97.7777L95.5799 22.0391H94.0742L97.1154 28.956L95.3993 32.6782H96.8292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.386 22.0391C88.5363 22.0391 87.6487 23.1414 87.3933 23.8115L88.6563 24.3475C88.9121 23.6623 89.649 23.2902 90.4162 23.2902C91.454 23.2902 92.3412 23.9602 92.3412 25.0626V25.2712C92.0553 25.1073 91.3336 24.8241 90.3409 24.8241C88.6112 24.8241 87.1074 25.7179 87.1074 27.371C87.1074 28.8905 88.3555 29.8138 89.8596 29.8138C91.123 29.8138 91.8749 29.1733 92.2809 28.5627H92.3412V29.5754H93.6646V25.1667C93.6646 23.1115 92.1906 22.0391 90.386 22.0391ZM90.0848 28.5629C89.3631 28.5629 88.5508 28.1756 88.5508 27.4011C88.5508 26.7307 89.1223 25.9565 90.5813 25.9565C91.7541 25.9565 92.3408 26.4328 92.3408 26.4328C92.3408 27.6245 91.1826 28.5629 90.0848 28.5629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0605 19.1743H86.29V29.8135H85.0605V19.1743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4997 19.1748H76.8672V29.814H78.2368V25.5048H80.4997C82.2709 25.5048 83.8342 24.1973 83.8342 22.34C83.8342 20.4826 82.2709 19.1748 80.4997 19.1748ZM80.5288 24.1976H78.2363V20.4829H80.5288C81.7494 20.4829 82.4342 21.4932 82.4342 22.3403C82.4342 23.187 81.7494 24.1976 80.5288 24.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2277 26.1897C67.1863 24.8074 68.3167 24.1031 69.1303 24.1031C69.7646 24.1031 70.3021 24.4148 70.4813 24.8616L67.2277 26.1897ZM69.2548 29.8756C70.923 29.8756 71.8879 28.8727 72.2878 28.2903L71.0471 27.4772C70.6334 28.0735 70.068 28.4665 69.2548 28.4665C68.4412 28.4665 67.862 28.1006 67.49 27.3824L72.3567 25.4041L72.1913 24.9976C71.8879 24.1983 70.9643 22.7212 69.0755 22.7212C67.2005 22.7212 65.6426 24.1712 65.6426 26.2985C65.6426 28.3039 67.1867 29.8756 69.2548 29.8756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2695 29.6591H64.8688V19.1445H63.2695V29.6591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1695 29.3606C62.1695 32.0029 60.5841 33.0867 58.709 33.0867C56.9443 33.0867 55.8825 31.9216 55.4826 30.9729L56.8753 30.4041C57.1236 30.9865 57.73 31.6776 58.709 31.6776C59.9084 31.6776 60.653 30.9458 60.653 29.5774V29.0625H60.5979C60.2393 29.4961 59.5498 29.8756 58.6814 29.8756C56.8616 29.8756 55.1934 28.3174 55.1934 26.3121C55.1934 24.2932 56.8616 22.7212 58.6814 22.7212C59.5498 22.7212 60.2393 23.1006 60.5979 23.5208H60.653V22.938H62.1695V29.3606ZM56.793 26.3121C56.793 27.5586 57.7165 28.4665 58.8197 28.4665C59.9087 28.4665 60.7637 27.5586 60.7637 26.3121C60.7637 25.0518 59.9087 24.1306 58.8197 24.1306C57.7165 24.1306 56.793 25.0518 56.793 26.3121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5278 26.2985C54.5278 28.3581 52.8872 29.8756 50.8743 29.8756C48.8613 29.8756 47.2207 28.3581 47.2207 26.2985C47.2207 24.2254 48.8613 22.7212 50.8743 22.7212C52.8872 22.7212 54.5278 24.2254 54.5278 26.2985ZM48.8203 26.2986C48.8203 27.5721 49.7715 28.4665 50.8746 28.4665C51.9774 28.4665 52.9289 27.5721 52.9289 26.2986C52.9289 25.0111 51.9774 24.1306 50.8746 24.1306C49.7715 24.1306 48.8203 25.0111 48.8203 26.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5594 26.2985C46.5594 28.3581 44.9188 29.8756 42.9059 29.8756C40.8929 29.8756 39.252 28.3581 39.252 26.2985C39.252 24.2254 40.8929 22.7212 42.9059 22.7212C44.9188 22.7212 46.5594 24.2254 46.5594 26.2985ZM40.8516 26.2986C40.8516 27.5721 41.8027 28.4665 42.9059 28.4665C44.0087 28.4665 44.9602 27.5721 44.9602 26.2986C44.9602 25.0111 44.0087 24.1306 42.9059 24.1306C41.8027 24.1306 40.8516 25.0111 40.8516 26.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.421 29.876C35.1033 29.876 36.3716 29.3339 37.3641 28.3179C38.3846 27.315 38.7017 25.906 38.7017 24.7676C38.7017 24.4156 38.6741 24.0903 38.619 23.8193H33.421V25.3368H37.1159C37.0056 26.1905 36.7164 26.8136 36.2751 27.2473C35.7373 27.7758 34.8961 28.3585 33.421 28.3585C31.1461 28.3585 29.3675 26.5564 29.3675 24.3207C29.3675 22.085 31.1461 20.2829 33.421 20.2829C34.6483 20.2829 35.5442 20.7569 36.2061 21.3668L37.2952 20.2965C36.3716 19.4292 35.1443 18.7651 33.421 18.7651C30.3052 18.7651 27.6855 21.2583 27.6855 24.3207C27.6855 27.3828 30.3052 29.876 33.421 29.876Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7721 13.1686C31.723 13.2326 31.6547 13.3034 31.5672 13.3812C31.4796 13.459 31.3671 13.5315 31.2294 13.5986C31.0917 13.6657 30.9263 13.7222 30.7331 13.768C30.5399 13.8139 30.3131 13.8368 30.0527 13.8368C29.7603 13.8368 29.4919 13.7867 29.2475 13.6865C29.0031 13.5863 28.7934 13.4414 28.6184 13.2517C28.4433 13.0621 28.3073 12.8287 28.2101 12.5516C28.113 12.2746 28.0645 11.9581 28.0645 11.6022V11.2953C28.0645 10.9415 28.1082 10.6255 28.1957 10.3474C28.2832 10.0693 28.4092 9.8343 28.5735 9.64248C28.7379 9.45067 28.9385 9.30468 29.1755 9.20451C29.4124 9.10434 29.6813 9.05426 29.9823 9.05426C30.2662 9.05426 30.5138 9.09102 30.7251 9.16455C30.9364 9.23808 31.1146 9.34091 31.2598 9.47305C31.4049 9.60519 31.5191 9.76237 31.6024 9.94459C31.6856 10.1268 31.7411 10.3266 31.7689 10.544H30.9748C30.9556 10.4225 30.9236 10.3106 30.8788 10.2083C30.834 10.106 30.7726 10.0176 30.6947 9.94299C30.6168 9.86839 30.5207 9.80979 30.4065 9.76716C30.2923 9.72454 30.1563 9.70322 29.9983 9.70322C29.8083 9.70322 29.6434 9.73839 29.5036 9.80872C29.3638 9.87905 29.2475 9.98188 29.1546 10.1172C29.0618 10.2526 28.9924 10.4188 28.9465 10.6159C28.9006 10.8131 28.8777 11.0374 28.8777 11.2889V11.6022C28.8777 11.8579 28.9054 12.0844 28.9609 12.2815C29.0164 12.4786 29.0959 12.6443 29.1995 12.7786C29.303 12.9129 29.4289 13.0152 29.5773 13.0855C29.7256 13.1558 29.8937 13.191 30.0816 13.191C30.2203 13.191 30.3393 13.1819 30.4385 13.1638C30.5378 13.1457 30.6216 13.1228 30.6899 13.0951C30.7582 13.0674 30.8142 13.037 30.858 13.004C30.9017 12.971 30.9375 12.9395 30.9652 12.9097V11.9986H30.0047V11.3848H31.7721V13.1686ZM35.3866 11.6947H33.4719V13.1269H35.71V13.7726H32.6619V9.11799H35.6876V9.77015H33.4719V11.0553H35.3866V11.6947ZM39.739 9.77014H38.2854V13.7726H37.4818V9.77014H36.041V9.11798H39.739V9.77014ZM42.8362 13.7726H42.0294V9.11799H42.8362V13.7726ZM47.2019 9.77014H45.7483V13.7726H44.9447V9.77014H43.5039V9.11798H47.2019V9.77014ZM53.1665 11.5669C53.1665 11.9207 53.1201 12.2377 53.0273 12.518C52.9344 12.7983 52.8037 13.0359 52.635 13.2309C52.4664 13.4259 52.2636 13.5756 52.0267 13.6801C51.7898 13.7845 51.5272 13.8367 51.2391 13.8367C50.9531 13.8367 50.6916 13.7845 50.4547 13.6801C50.2177 13.5756 50.0134 13.4259 49.8415 13.2309C49.6697 13.0359 49.5363 12.7983 49.4413 12.518C49.3463 12.2377 49.2988 11.9207 49.2988 11.5669V11.3304C49.2988 10.9766 49.3463 10.659 49.4413 10.3777C49.5363 10.0964 49.6686 9.85768 49.8383 9.6616C50.008 9.46553 50.2113 9.31528 50.4483 9.21085C50.6852 9.10641 50.9467 9.0542 51.2327 9.0542C51.5208 9.0542 51.7839 9.10641 52.0219 9.21085C52.2599 9.31528 52.4638 9.46553 52.6334 9.6616C52.8031 9.85768 52.9344 10.0964 53.0273 10.3777C53.1201 10.659 53.1665 10.9766 53.1665 11.3304V11.5669ZM52.355 11.3241C52.355 11.0641 52.33 10.8344 52.2798 10.6352C52.2296 10.4359 52.1565 10.2691 52.0605 10.1348C51.9644 10.0006 51.8465 9.89881 51.7067 9.82955C51.5669 9.76028 51.4084 9.72565 51.2312 9.72565C51.0583 9.72565 50.9025 9.76028 50.7638 9.82955C50.625 9.89881 50.5071 10.0006 50.41 10.1348C50.3129 10.2691 50.2382 10.4359 50.1859 10.6352C50.1336 10.8344 50.1074 11.0641 50.1074 11.3241V11.567C50.1074 11.8271 50.1336 12.0572 50.1859 12.2576C50.2382 12.4579 50.3134 12.6257 50.4116 12.7611C50.5098 12.8964 50.6288 12.9987 50.7686 13.068C50.9084 13.1372 51.0647 13.1719 51.2376 13.1719C51.5962 13.1719 51.8721 13.0355 52.0653 12.7627C52.2585 12.4899 52.355 12.0913 52.355 11.567V11.3241ZM57.6705 13.7726H56.8605L54.7826 10.4703V13.7726H53.9725V9.11799H54.7826L56.8669 12.4331V9.11799H57.6705V13.7726Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2226_2279",
    x1: 23.8956,
    y1: 23.8249,
    x2: 22.0811,
    y2: 10.2698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3264,
    stopColor: "#93E2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2226_2279",
    x1: 6.16169,
    y1: 18.916,
    x2: 11.3894,
    y2: 33.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF177B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6721,
    stopColor: "#FFA976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2226_2279",
    x1: 17.2531,
    y1: 25.5865,
    x2: 5.90196,
    y2: 13.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#32A0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    stopColor: "#1262A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2226_2279",
    x1: 20.5198,
    y1: 22.5445,
    x2: 4.3321,
    y2: 26.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3411,
    stopColor: "#D43E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7935,
    stopColor: "#9F36B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A33DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.374,
    height: 39.8083,
    fill: "white",
    transform: "translate(0.636719 0.760742)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2226_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.8496,
    height: 25.7795,
    fill: "white",
    transform: "translate(7.60352 8.94434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2226_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5979,
    height: 18.0047,
    fill: "white",
    transform: "translate(7.60352 16.7192)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2226_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.7682,
    height: 14.5266,
    fill: "white",
    transform: "translate(27.6855 18.7651)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-play.62d1ce8f5f3027c644085b399d56b9da.svg";